module.exports = __webpack_public_path__ + "static/media/logo_v.65f5356e.svg";